export enum TourId {
	quickstart = "quickstart",
	sendEmail = "send_email",
	sendSlack = "send_slack_message",
}
